export function getFullName(participant) {
    var _a, _b;
    const firstName = (_a = participant.usage_first_name) !== null && _a !== void 0 ? _a : participant.first_name;
    const lastName = (_b = participant.usage_last_name) !== null && _b !== void 0 ? _b : participant.last_name;
    return `${firstName} ${lastName}`;
}
export function getNames(participant) {
    var _a, _b;
    const firstName = (_a = participant.usage_first_name) !== null && _a !== void 0 ? _a : participant.first_name;
    const lastName = (_b = participant.usage_last_name) !== null && _b !== void 0 ? _b : participant.last_name;
    return [firstName, lastName];
}
export function getFirstNameWithLastNameInitial(participant) {
    var _a, _b;
    const firstName = (_a = participant.usage_first_name) !== null && _a !== void 0 ? _a : participant.first_name;
    const lastName = (_b = participant.usage_last_name) !== null && _b !== void 0 ? _b : participant.last_name;
    return `${firstName} ${lastName[0]}.`;
}
export function getInitials(participant) {
    var _a, _b;
    const firstName = (_a = participant.usage_first_name) !== null && _a !== void 0 ? _a : participant.first_name;
    const lastName = (_b = participant.usage_last_name) !== null && _b !== void 0 ? _b : participant.last_name;
    return `${firstName[0]}${lastName[0]}`;
}
//# sourceMappingURL=nameHelpers.js.map